import { cn } from '@/lib/ui/cn';
import { BlockListProps } from '@/types/blocks';
import clsx from 'clsx';

export function List(props: BlockListProps) {
  const {
    heading,
    subheading,
    items = [],
    backgroundColor,
    beforeContent,
    afterContent,
    toggle,
    className,
    innerClassName,
  } = props;

  const iswhiteBackground = backgroundColor === 'white';

  return (
    <>
      <section
        className={clsx(
          'space-y-4 rounded-4xl p-5 md:p-10 lg:space-y-8',
          className
        )}
      >
        {beforeContent}
        <section
          className={cn(
            innerClassName,
            toggle === false ? 'hidden md:block' : 'block'
          )}
        >
          {heading && (
            <h1 className='sh-heading-3 mb-4 lg:mb-8.5'>{heading}</h1>
          )}
          {subheading && <p className='sh-body mb-4 lg:mb-8.5'>{subheading}</p>}
          <ul className={clsx('space-y-5 lg:space-y-8')}>
            {items.map((item, index) => (
              <li key={index} className='flex items-center'>
                <div
                  aria-hidden='true'
                  className={cn(
                    'mr-5 mb-0 flex size-8 flex-none items-center justify-center rounded-full',
                    iswhiteBackground ? 'bg-sh-metal' : 'bg-sh-dark-gray'
                  )}
                >
                  <svg
                    viewBox='0 0 20 20'
                    fill='var(--color-sh-white)'
                    className='size-6'
                  >
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 0 1 0 1.414l-7.25 7.25a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414l2.293 2.293 6.543-6.543a1 1 0 0 1 1.414 0z'
                      clipRule='evenodd'
                    />
                  </svg>
                </div>
                <div className='sh-body text-gray-900'>{item.text}</div>
              </li>
            ))}
          </ul>
        </section>
        {afterContent}
      </section>
    </>
  );
}
